import { BotMessageSquare } from "lucide-react";
import React from "react";

import { Card } from "@/components/ui/card";
import { cn } from "@/lib/utils";

interface ChatPreviewProps {
    className?: string;
    title?: string;
    message?: string;
}

const ChatPreview: React.FC<ChatPreviewProps> = ({ className, title, message }) => {
    return (
        <div className={cn(className)}>
            <h3 className="mb-2 text-xl font-bold text-gray-700">Preview</h3>
            <div className="flex h-full items-center justify-center rounded-lg bg-blue-50 p-3">
                <div className="flex max-w-96 flex-col items-end">
                    <Card className="rounded-lg bg-white p-4 text-gray-700 shadow-lg">
                        <h3 className="text-xl font-bold">{title || "Step & Feet"}</h3>
                        <div className="my-2 flex items-center gap-2">
                            <div className="size-2 rounded-full bg-green-500"></div>
                            <p className="text-sm font-bold text-gray-500">Active</p>
                        </div>
                        <p className="text-sm text-gray-500">
                            {message || "Hi, I'm Shoe AI Chatbot and I'm here to help you with your queries. How can I help you today?"}
                        </p>
                    </Card>
                    <div className=" mt-2 flex size-14 items-center justify-center rounded-full border bg-white text-blue-500 shadow-lg">
                        <BotMessageSquare />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ChatPreview;
